import { BulletsLoading } from '@/common/components/BulletsLoading/BulletsLoading';
import { Stack } from '@/common/components/Stack/Stack';

export const LoadingPlaceholder = () => {
  return (
    <Stack
      data-test-id="loading"
      align="center"
      justify="center"
      className={styles.root}
    >
      <BulletsLoading />
    </Stack>
  );
};

const styles = {
  root: 'w-full h-full py-[10rem]',
};
